import { render } from "./OrdersDelivered.vue?vue&type=template&id=da9b4f12&scoped=true"
import script from "./OrdersDelivered.vue?vue&type=script&lang=js"
export * from "./OrdersDelivered.vue?vue&type=script&lang=js"

import "./OrdersDelivered.vue?vue&type=style&index=0&id=da9b4f12&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da9b4f12"]])

export default __exports__